import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { fadeIn } from '../../utils/animations';

interface CardProps {
  variant?: 'default' | 'elevated' | 'outlined';
}

export const Card = styled.div<CardProps>`
  background-color: ${({ theme }) => theme.colors.cardBackground};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => theme.spacing.lg};
  box-shadow: ${({ theme }) => theme.shadows.md};
  transition: all ${({ theme }) => theme.transitions.normal};
  animation: ${fadeIn} 0.4s ease-out;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.lg};
    transform: translateY(-2px);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;